import { initializeApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { Analytics, getAnalytics, isSupported, logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCQkG60jCBUXgfDXpv-lKQgt_qJ7DMblYA",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "haitatsu-web.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "haitatsu-web",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "haitatsu-web.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "180686503773",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:180686503773:web:bef22c5c96f04e1946b2b4",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-7SBM1EFJ4W"
};

const app = initializeApp(firebaseConfig);

// Firestore初期化
export const db = getFirestore(app);

// オフライン永続化を有効化（本番環境のみ）
if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  enableIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
      console.warn('複数のタブが開かれています。永続化は1つのタブでのみ有効です。');
    } else if (err.code === 'unimplemented') {
      console.warn('ブラウザが永続化をサポートしていません。');
    }
  });
}

// Analytics初期化（本番環境のみ）
let analytics: Analytics | null = null;
const analyticsReady = process.env.NODE_ENV === 'production'
  ? isSupported()
      .then((supported) => {
        if (supported) {
          analytics = getAnalytics(app);
        }
        return analytics;
      })
      .catch(() => null)
  : Promise.resolve(null);

export const trackAnalyticsEvent = async (
  eventName: string,
  params?: Record<string, string | number | boolean>
) => {
  const instance = analytics || await analyticsReady;
  if (!instance) return;
  logEvent(instance, eventName, params);
};

export { analytics };
export default app;
